module.exports = __webpack_public_path__ + "img/parking_1.0aede416.jpeg";